const styles = () => ({
    listItem: {
        cursor: 'pointer',
        fontSize: '12px',
    },
    date: {
        margin: '0',
        fontWeight: 'bold',
    },
    request: {
        textAlign: 'right',
        fontStyle: 'italic',
        margin: '0',
    },
    dae: {
        margin: '0',
    },
    value: {
        margin: '0',
    },
    alertContainer: {
        overflow: 'hidden',
        paddingBottom: '20px',
        '& h3': {
            fontWeight: 'bold',
            color: '#666',
            marginBottom: '5px',
        },
        '& p': {
            margin: '0',
        },
    },
    internalContainer: {
        minHeight: '340px',
    },
    alertButtonContainer: {
        textAlign: 'center',
        marginTop: '20px',
    },
    alertButtonCta: {
        padding: '15px',
    },
    textRight: {
        textAlign: 'right',
        fontSize: '12px',
    },
    textLeft: {
        fontSize: '12px',
    },
    centerProgress: {
        textAlign: 'center',
        margin: '30px 0 10px',
    },
});

export default styles;
